"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class AssetReset extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'assetReset';
        this._assetId = initParams.asset_id;
        this._timestamp = initParams.timestamp;
        this._value = initParams.value;
        this._start = initParams.start;
        this._end = initParams.end;
    }
    set assetId(value) {
        console.error('Do not set objects this way');
    }
    setAssetId(value) {
        return this.dataService.updateAssetReset(this.id, { asset_id: value }, this);
    }
    get assetId() {
        return this._assetId;
    }
    set timestamp(value) {
        console.error('Do not set objects this way');
    }
    setTimestamp(value) {
        return this.dataService.updateAssetReset(this.id, { timestamp: value }, this);
    }
    get timestamp() {
        return this._timestamp;
    }
    set value(value) {
        console.error('Do not set objects this way');
    }
    setValue(value) {
        return this.dataService.updateAssetReset(this.id, { value: value }, this);
    }
    get value() {
        return this._value;
    }
    set start(value) {
        console.error('Do not set objects this way');
    }
    setStart(value) {
        return this.dataService.updateAssetReset(this.id, { start: value }, this);
    }
    get start() {
        return this._start;
    }
    set end(value) {
        console.error('Do not set objects this way');
    }
    setEnd(value) {
        return this.dataService.updateAssetReset(this.id, { end: value }, this);
    }
    get end() {
        return this._end;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateAssetReset(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
    delete() {
        return this.dataService.deleteAssetReset(this.id, this);
    }
}
exports.default = AssetReset;
//# sourceMappingURL=assetReset.js.map